import React from 'react';
import styled from 'styled-components';

import withi18n from '~/utils/withI18n';

import IconWithBG from '~/components/IconWithBG';
import Icon from '~/components/Icon';

type Props = {
  onCancel: Function,
  visible: Boolean,
  goShare: Function,
  translate: Function,
};

export default ({ visible, goShare, onCancel, translate }: Props) => {
  return (
    <Wrapper onClick={onCancel} visible={visible}>
      <Content onClick={e => e.stopPropagation()}>
        <Text>{`${translate('shareNow')}!`}</Text>
        <div>
          <IconWithBG
            type="twitter"
            width={50}
            color="#1E91F1"
            bgColor="#FFF"
            size={20}
            border="1px solid #EAECEF"
            onClick={() => goShare('twitter')}
          />
          <IconWithBG
            type="weibo"
            width={50}
            color="#D22428"
            bgColor="#FFF"
            size={20}
            border="1px solid #EAECEF"
            margin=" 0 0 0 60px"
            onClick={() => goShare('weibo')}
          />
        </div>
        <Close onClick={onCancel}>
          <Icon type="Close-x" color="#FFF" />
        </Close>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: rgba(0, 0, 0, 0.5);
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
`;

const Content = styled.div`
  width: 284px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
  border-radius: 3px;
  position: relative;
`;
const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #212833;
  margin-bottom: 16px;
  width: 224px;
  text-align: center;
`;
const Close = styled.div`
  position: absolute;
  right: -20px;
  top: 0px;
`;
